import { UseFormReturn } from "react-hook-form";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { IModuleVärmePrimärFjärrRound } from "../../../types/ModuleDatas";
import NumberEditor from "../../Global/Editors/NumberEditor";
import { nameof } from "../../Global/Utils";
import StaticBox from "../../Global/StaticBox";
import { MapTooltip } from "../../../types/globalData";
import BFLNote from "../BFL/BFLNote";

interface IProps {
  module: IModuleRound;
  data: any;
  formHook: UseFormReturn;
}

const RoundVarmePrimarFjarr = ({ module, data, formHook }: IProps) => {
  const roundHandler = useRound();

  const lastRound = roundHandler.getLastFinishedRound();
  const lastRoundModule = lastRound?.data.modules.find((m) => m.id === module.id);

  const previousMeasureM3 = lastRoundModule ? lastRoundModule.data[nameof<IModuleVärmePrimärFjärrRound>("mätvärdeM3")] : 0;
  const previousMeasureMWh = lastRoundModule ? lastRoundModule.data[nameof<IModuleVärmePrimärFjärrRound>("mätvärdeMWh")] : 0;

  const saknarMätvarde = formHook.watch(nameof<IModuleVärmePrimärFjärrRound>("saknarMätvärde"));
  const harMätvarde = saknarMätvarde === "Nej";
  if (!saknarMätvarde) {
    formHook.setValue(nameof<IModuleVärmePrimärFjärrRound>("saknarMätvärde"), "Nej");
  }

  const isSummer = roundHandler.getActiveRound()?.isSummer as boolean;
  // const energikalla = watch("energikalla");

  return (
    <>
      {/* {isSummer ? (
        <div className="row ml-0 mt-4">
          <div style={{ margin: 20 }}>Ingen data behövs anges för att rondera under sommarrondering -Var vänlig och gå vidare genom att klicka på "Klar"</div>
        </div>
      ) : (
        <></>
      )} */}
      <div className="row ml-0">
        {/* <div className="col-lg-12">Ange mätvärden för pågående energirondering</div> */}
        <div className="col-lg-12">
          <SelectEditor
            label="Ange om mätvärden från fjärrvärmemätaren saknas"
            formHook={formHook}
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("saknarMätvärde")}
            items={["Nej", "Ja"]}
          ></SelectEditor>
        </div>
        {harMätvarde ? (
          <>
            <div className="col-lg-6">
              <NumberEditor
                label="Värmemängdsmätare Fjärrvärme m³ ackumulerat 12 månaders värde"
                fieldName={nameof<IModuleVärmePrimärFjärrRound>("mätvärdeM3")}
                tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_mätvärdeM3")}
                formHook={formHook}
                options={{
                  validate: {
                    required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
                  },
                }}
              ></NumberEditor>
            </div>
            <div className="col-lg-6">
              <NumberEditor
                label="Värmemängdsmätare Fjärrvärme MWh ackumulerat 12 månaders värde"
                fieldName={nameof<IModuleVärmePrimärFjärrRound>("mätvärdeMWh")}
                tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_mätvärdeMWh")}
                formHook={formHook}
                options={{
                  validate: {
                    required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
                  },
                }}
              ></NumberEditor>
            </div>
          </>
        ) : (
          <></>
        )}

        {/* <div className="col-lg-12">Ackumulerat mätvärde vid föregående energirondering</div>
        <div className="col-lg-6">
          <StaticBox label="m³" text={previousMeasureM3} tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_mätvärdeM3Ack")}></StaticBox>
        </div>
        <div className="col-lg-6">
          <StaticBox label="MWh" text={previousMeasureMWh} tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_mätvärdeMWhAck")}></StaticBox>
        </div> */}

        <div className="col-lg-12">
          <NumberEditor
            label="Temperatur utegivare °C"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("temperaturUtegivare")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_temperaturUtegivare")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>

        <div className="col-lg-6">
          <NumberEditor
            label="Tilloppstemp primärsida(°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("tilloppstempPrimär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_tilloppstempPrimär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Returtemp primärsida(°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("returTempPrimär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_returTempPrimär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Tilloppstemp sekundärsida (°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("tilloppstempSekundär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_tilloppstempSekundär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
        <div className="col-lg-6">
          <NumberEditor
            label="Returtemp sekundärsida (°C)"
            fieldName={nameof<IModuleVärmePrimärFjärrRound>("returTempSekunär")}
            tooltipId={nameof<MapTooltip>("VärmePrimärFjärr_returTempSekunär")}
            formHook={formHook}
            options={{
              validate: {
                required: (value: any) => (value || value === 0 ? undefined : "Måste anges"),
              },
            }}
          ></NumberEditor>
        </div>
      </div>
      <BFLNote formHook={formHook} />
    </>
  );
};

export default RoundVarmePrimarFjarr;
